import { Controller } from "stimulus"
import { ChatSessionPreferenceService } from "../services/chat_session_preference_service"
export default class extends Controller {
  close() {
    this.element.style.display = 'none'

    new ChatSessionPreferenceService().updatePreference({ notify: false })
  }
}